import { createReducer, on } from '@ngrx/store';
import * as courseAction from './course.action';
import { coursedetailsState } from './course.modal'

export const initialState: coursedetailsState = {
    course_id: null,
    course_type: '',
    course_details: null,
    course_structure: [],
    course_achievements: null,
    course_price: null
};

export const courseReducer = createReducer(
  initialState,
  on(courseAction.setCourseAllData, (state, { data }) => ({
    ...state,
    course_id: data.course_id,
    course_type: data.course_type,
    course_details: data.course_details,
    course_structure: data.course_structure,
    course_achievements: data.course_achievements,
    course_price: data.course_price
  })),

  on(courseAction.setCourseDetails, (state, { data }) => ({
    ...state,
    course_details: data
  })),

  on(courseAction.setCourseStructure, (state, { data }) => ({
    ...state,
    course_structure: Array.isArray(data) ? data : [data]
  })),

  on(courseAction.setCoursePrice, (state, { data }) => ({
    ...state,
    course_price: data
  })),

  on(courseAction.setCourseAchievements, (state, { data }) => ({
    ...state,
    course_achievements: data
  })),

  on(courseAction.emptyCourseAllData, (state) => ({
    ...state,
    course_id: null,
    course_type: '',
    course_details: null,
    course_structure: [],
    course_achievements: null,
    course_price: null
  }))

);